module.exports = __webpack_public_path__ + "static/media/Prayer.11878668.jpg";